import React from 'react';
import ResourceInventoriesContainer from '../../components/resources/ResourceInventoriesContainer';

const ResourceInventories = () => {
  return <ResourceInventoriesContainer />;
}

export default ResourceInventories;
